export const getLoadProfileDetailsPayload = ({ device, companyId, from, to, config }) => ({
  params: {
    deviceIds: JSON.stringify([device.id]),
    from: from,
    to: to,
    companyId: companyId,
    source: device.source,
  },
  ...config,
})

export const postPeakLoadTrendsPayload = ({ device, companyId }) => ({
  deviceIds: [device.id],
  companyId: companyId,
  source: device.source,
})

export const postConsumptionTrendsPayload = ({ device }) => ({
  deviceIds: [device.id],
  companyId: device.companyId,
  source: device.source,
})

export const getConsumptionTrendsPayload = ({ companyFirebaseId, regionId, locationId, buildingId }) => ({
  params: {
    companyFirebaseId,
    regionId,
    locationId,
    buildingId,
  },
})
